// frontend/src/features/campaign/components/list/CampaignStatusFilter.js
import React from 'react';
import { STATUS_OPTIONS } from '../../constants/campaignConstants';

export default function CampaignStatusFilter({ selectedStatus, onSelectStatus, statusCounts }) {
  return (
    <div className="cmp-status-filter-row">
      <span className="cmp-filter-label">
        <i className="fas fa-filter" /> Status:
      </span>
      <div className="cmp-filter-pills">
        {STATUS_OPTIONS.map((opt) => {
          const count = statusCounts[opt.key] || 0;
          const isActive = selectedStatus === opt.key;
          return (
            <button
              key={opt.key}
              className={`cmp-filter-pill ${isActive ? 'active' : ''}`}
              onClick={() => onSelectStatus(opt.key)}
            >
              <span>{opt.label}</span>
              <span className="cmp-pill-count">{count}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
